import {
  UPDATE_ACCESS_TEMPLATE_SUCCESS,
  UPDATE_ACCESS_TEMPLATE_FAIL,
  ADD_ACCESS_TEMPLATE_SUCCESS,
  ADD_ACCESS_TEMPLATE_FAIL,
  ACCESS_TEMPLATE_LIST_SUCCESS,
  ACCESS_TEMPLATE_LIST_FAIL,
  ASSIGN_ACCESS_SUCCESS,
  ASSIGN_ACCESS_FAIL,
  GET_ACCESS_TEMPLATE_SUCCESS,
  GET_ACCESS_TEMPLATE_FAIL,
  GET_ACCESS_TEMPLATE,
} from "./actionTypes";

const initialState = {
  error: [],
  res: [],
  list: [],
  template: [],
};

const RoleAccess = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCESS_TEMPLATE:
      return {
        ...state,
        template: [],
      };
    case GET_ACCESS_TEMPLATE_SUCCESS:
      return {
        ...state,
        template: action.payload,
      };
    case GET_ACCESS_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ASSIGN_ACCESS_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ASSIGN_ACCESS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ACCESS_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case ACCESS_TEMPLATE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_ACCESS_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_ACCESS_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_ACCESS_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_ACCESS_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default RoleAccess;
